import React from "react";
import "../../../css/Grupo3/G3Landing.css";
import InscripcionComponent from "../../../Component/Grupo3/InscripcionComponent";

function Vista3() {
  return (
    <div className="wrapper">
      <InscripcionComponent />
    </div>
  );
}

export default Vista3;
